var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg80GDowload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_7052644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "06-give"
  }, /*#__PURE__*/React.createElement("g", {
    id: "glyph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1433 14.7813C20.5568 14.477 19.4668 14.0362 18.6585 14.4403L16.3388 15.6002H12.2791L9.95935 13.2804H14.019C14.4804 13.2804 14.9229 13.0971 15.2492 12.7708C15.5755 12.4445 15.7588 12.002 15.7588 11.5406V11.2506C15.7588 11.1737 15.7283 11.0999 15.6739 11.0456C15.6195 10.9912 15.5457 10.9606 15.4688 10.9606H3V16.1801L9.87007 18.4702C9.92925 18.4899 9.99122 18.4999 10.0536 18.4999H16.1633C16.2778 18.4999 16.3897 18.466 16.485 18.4025L21.1695 15.2794C21.2114 15.2515 21.2453 15.2132 21.2679 15.1682C21.2904 15.1232 21.3009 15.0731 21.2983 15.0229C21.2956 14.9726 21.28 14.9239 21.2528 14.8816C21.2256 14.8392 21.1879 14.8046 21.1433 14.7813Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.64036 8.64086H8.80025V5.74113H9.96014V4.58124H6.48047V5.74113H7.64036V8.64086Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3431 8.06091H12.6335L12.888 8.82427L13.9883 8.45745L12.8285 4.97778C12.79 4.86231 12.7161 4.76188 12.6174 4.69071C12.5186 4.61954 12.4 4.58124 12.2783 4.58124H11.6984C11.5766 4.58124 11.458 4.61953 11.3593 4.6907C11.2605 4.76187 11.1867 4.8623 11.1482 4.97778L9.98828 8.45745L11.0887 8.82427L11.3431 8.06091ZM12.247 6.90102H11.7297L11.9883 6.12534L12.247 6.90102Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.3344 8.72216L16.3388 7.517L17.3431 8.72216L18.2342 7.97961L17.0937 6.61105L18.2342 5.24249L17.3431 4.49994L16.3388 5.7051L15.3344 4.49994L14.4434 5.24249L15.5838 6.61105L14.4434 7.97961L15.3344 8.72216Z",
    fill: "#686868"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg80GDowload);
export default __webpack_public_path__ + "static/media/80g-dowload.74d96b8505c82ae69b30ab23d0d339eb.svg";
export { ForwardRef as ReactComponent };